// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import individualDiagnose from '../../../share/util/individualDiagnose';
import api from '../../../common/api';
import handler from '../../../share/util/apiResultValidator';
import alert from '../../../share/alert';
import loading from '../../../share/components/vue/ProcessingIcon';
import util from '../../../share/util/utils';
import eventLogUtil from '../../../share/util/eventLogUtil';

import cstmTable from '../../../share/components/vue/PaginationTable';
import ffdModal from '../../vue/FFDModal';
import logWrapper from '../../../share/logWrapper';
import diagnoResource from '../../../share/util/diagnose';
import resource from '../../../share/util/resourceMap';

import memoPage from '../../vue/MemoPage';
import constants from '../../../common/nodejs/constants';
import customProgress from "../../../share/components/vue/CustomProgress";
import ApiService from '../../../share/util/api/service';
import diag from '../../../share/util/diagnose';
import { DTC } from "../../../constants/usageCountTypes";
import DiagSystemUtils from '../../../common/nodejs/diagSystemUtils';
import { getMeasuredDataName, getCsvFileName } from '../../../util/fileExport';
import { getAbbrSysName } from '../../../share/util/systemName';

const CHAIN_DTC_MAP = [
  { type: 'normal', label: 'message.button_vehicle_dtc_chain_dtc_normal' },
  { type: 'all', label: 'message.button_vehicle_dtc_chain_dtc_all' }
];

// アクション一覧
const DIAG_INIT = "init";
const DIAG_GET_DTC = "diag_get_dtc";
const DIAG_GET_FFD = "diag_get_ffd";
const DIAG_READINESS = "readiness_code";
const DIAG_MEMORY_CLEAR = "diag_memory_clear";

export default {
  name: "IndividualDiagCode",
  data() {
    return {
      processing: false,
      isUseCache: true,
      measuredId: null,
      isShowStopBtn: false,
      timer: null,
      isExecution: false,
      pollingProcessing: false,

      getDiagCodeListResponse: null,
      dtcSystemTableColumns: [],
      dtcListItems: [],
      isEnableClearDtc: false,
      // FFD一覧
      ffdTitle: '',
      ffdSystem: '',
      ffdDescription: '',
      ffdSystemTable: [],
      selectedSystem: null,
      testModeVisible: false,
      chainDtcType: 'normal',
      // レディネスコード
      readinessCodeTable: [],
      readinessCodeInputDtc: '',
      readinessCodeValidateDtc: undefined,
      readinessCodeMeasuredId: null,
      modalFfd: false,
      modalReadiness: false,
      modalMemo: false,
      isMemoDialogLoading: false,
      isSignOut: false,
      // テストモード時のメモ情報保持変数
      memoData: {
        diagnoseComment: null,
        dataName: 'data1',
        memo: null
      },
    };
  },

  props: {
    obdFunctionLabelKey: { type: String, required: false, default: "" },
    functionNameKey: { type: String, required: false, default: 'individual.individual_diagnosis_function_diag_code' },
    destinationAPI: { type: String, required: false, default: ApiService.DIAG },
    limitedHeightMode: { type: Boolean, required: false, default: false },
  },

  components: {
    'processing-view': loading,
    'cstm-table': cstmTable,
    'ffd-modal': ffdModal,
    'memo-Page': memoPage,
    // vue warn 回避
    'custom-Progress': customProgress,
  },

  watch: {
    language: {
      /**
       * 言語変更を監視する
       */
      handler(val) {
        val; // To avoid warning
        this.updateDTCTable();
        this.updateColumns();
      }
    },

    /**
     * ポーリング状態を監視して親に通知（統合画面用）
     */
    pollingProcessing(val) {
      const currentStatus = { feature: 'dtc', status: val ? 'polling' : 'completed' };
      this.$emit('diagApiStatusChange', currentStatus);
    },

    // レディネスコードを開いた時、以前に追加していたDTCをそのまま保持していると画面上に反映されないため、
    modalReadiness: {
      handler(val) {
        if (val) {
          this.readinessCodeTable = Array.from(this.readinessCodeTable);
        }
      },
    }
  },

  // 遷移してきた画面のパラメータ情報を保持
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      vm.beforeRouteProcess(vm, from);
    });
  },

  /**
   * 遷移してきた画面のパラメータ情報を保持
   * 同一コンポーネントが再帰的に利用された場合、呼び出される
   */
  beforeRouteUpdate(to, from, next) {
    if (this.isPopstateNavigation) {
      this.cacheIsPopstateNavigation(false);
      next();
      return;
    }
    this.$nextTick(() => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      this.beforeRouteProcess(this, from);
      // テーブル情報クリア（本当は mountedLogic に入れたいが、影響範囲を考慮してここにピンポイントで入れている）
      // FFD キャッシュクリアやレディネスコードクリアは、moutedLogic 内でやっているので問題なし
      this.dtcListItems = [];
      // mounted時に行う共通処理を呼び出す
      this.mountedLogic();
    });
    next();
  },

  methods: {
    ...mapActions('table', ['updateAllDtcDataFromIndividualDtcData']),
    ...mapActions('cache', ['cacheFFDStores', 'cacheIsPopstateNavigation']),
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('observation', ['usageCountUp']),
    ...mapActions('app', ['setViewProcessMode']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // メモリクリアの活性判定をfalseに初期化
      this.isEnableClearDtc = false;
      this.init();
      // レディネスコードテーブルを初期化する
      this.allDeleteReadinessCode();

      // debug 環境のみ実施有効とする
      if (process.env.VUE_APP_DEBUG_LOG) {
        // テストボタン表示
        document.onkeydown = (event) => {
          if (event) {
            // Ctrl+Shift+V key detection
            if (event.shiftKey && event.ctrlKey) {
              if (event.code === "KeyV") {
                this.testModeVisible = true;
                return true;
              }
            }
          }
          return util.checkSSM5ValidCharacters(event);
        };
      }
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     * @param {string} action 処理内容
     */
    validateErrorResult(result, action) {
      // エラー発生時、ポーリングを停止する
      this.pollingStop();
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(action); },
      );
    },

    /**
     * DTCテーブル情報の更新を行う
     */
    async init() {
      // DTCの通信開始を親に通知（統合画面用）
      this.$emit('diagApiStatusChange', { feature: 'dtc', status: 'init' });
      try {
        // 初期化通信の実行
        this.processing = true;
        this.cacheFFDStores([]);
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.DIAG,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/initialize',
              {
                use_cache: this.isUseCache
              }
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.DIAG,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(DIAG_INIT); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_REPRO_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_REPRO_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_REPRO_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_INIT); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_INIT); },
        );

        if (response) {
          // 個別診断DTCの利用回数カウントアップ
          this.usageCountUp({ type: DTC, systemName: systemId });
          // 正常終了：ダイアグコードの取得を行う
          await this.getDiagCodeRequest();
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * 非同期でダイアグ取得を実行し、テーブル更新を行う
     * @param {boolean} eventLogHandleIdFlg 開始ボタンを押下して最初のダイアグ取得のみ true（イベントログの操作 ID 発行する）とする
     * @returns なし
     */
    async getDiagCodeRequest(eventLogHandleIdFlg = false) {
      try {
        // 個別 ECU の DTC データを取得する
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // DTCポーリング中のプロセスでは、独自フラグを切り替える
        if (this.isShowStopBtn) {
          this.pollingProcessing = true;
        } else {
          this.processing = true;
        }
        if (eventLogHandleIdFlg) {
          // イベントログの操作 ID 発行
          await eventLogUtil.createEventLogHandleId(this.netAppId);
        }
        // diagCode(要求)（バックエンドAPI_POST）
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.DIAG,
              `/netApps/${this.netAppId}/systems/${systemId}/diagDtc`,
              {
                current_measured_id: this.measuredId || undefined
              }
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.DIAG,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(DIAG_GET_DTC); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_REPRO_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_REPRO_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_REPRO_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_GET_DTC); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_GET_DTC); },
          process.env.VUE_APP_INDIVIDUAL_DTC_RETRY_COUNT,
          process.env.VUE_APP_INDIVIDUAL_DTC_RETRY_INTERVAL,
          true
        );

        if (response) {
          // 正常終了：ダイアグコードの一覧取得を行う
          // レスポンスの計測IDが存在し、その計測IDが前回と同じ場合、差分が無いのでreturn
          // 既にサインアウトしている場合もreturn
          if (response.data.measured_id && String(response.data.measured_id) === this.measuredId || this.isSignOut) {
            return;
          }
          this.measuredId = String(response.data.measured_id);
          this.getDiagCodeListResponse = await this.getDiagCodeList();
          // responseが存在しない場合、処理終了
          if (!this.getDiagCodeListResponse) {
            return;
          }
          // DTCのメモリクリアが可能か否かのフラグを設定する
          this.isEnableClearDtc = this.getDiagCodeListResponse.is_enabled_clear_individual_dtc;
          this.updateDTCTable();
          this.updateColumns();
          // DTC取得処理完了を親に通知（統合画面用）
          this.$emit('diagApiStatusChange', { feature: 'dtc', status: 'completed' });
        }
      } finally {
        // スピナーやレイヤーの消し忘れが無いように、
        // finally時にprocessingをfalseにする動作は、DTCポーリング中か同かに関わらず、どちらのフラグも行う
        this.processing = false;
        this.pollingProcessing = false;
      }
    },

    /**
     * 一覧取得処理を行う関数
     * @returns GetのResponse | null
     */
    async getDiagCodeList() {
      const systemId = individualDiagnose.getCurrentSystemId(this);
      // Get APIを呼び出す
      const projectId = this.vehicleInfo.vehicle.project.id;
      const response = await individualDiagnose.syncApi(
        this,
        async () => {
          return await api.getCall(
            config.DIAG,
            `/diagDtc/${projectId}/${this.measuredId}/dtc/${systemId}`,
            this.operationScreen
          );
        },
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(DIAG_GET_DTC); },
        // GET API で正常レスポンスが返ってきた際の内容チェック
        (getApiResponse) => {
          // data が入っていれば成功とする
          return getApiResponse && getApiResponse.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
        },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
        (result) => { this.validateErrorResult(result, DIAG_GET_DTC); },
      );
      // 処理失敗時は response が null になるので考慮
      return response ? response.data : null;
    },

    /**
     * Getのレスポンスのハンドリングを行う
     * @param response GetのResponse
     * @param currentRetry リトライ回数
     * @param retryMaxCount 最大リトライ可能回数
     * @param action 処理内容
     * @returns 処理結果{isCompleted: 終了判定(boolean), response: GetのResponse | null}
     */
    async getResponseHandler(response, currentRetry, retryMaxCount, action) {
      return new Promise((resolve) => {
        handler.validate(handler.validateTypes.all, response, this, null, () => {
          // 正常コールバック
          switch (response.data.status) {
            // 正常終了、異常終了
            case config.STATUS_REPRO_COMPLETED:
            case config.STATUS_REPRO_FAILED:
              return resolve({ isCompleted: true, response: response });
            default:
              // in_progress
              if (currentRetry >= retryMaxCount) {
                // リトライ回数上限値に達した場合も処理終了
                // 汎用エラー扱いの為、responseをnullで返す
                this.showUnexpectedError(action);
                return resolve({ isCompleted: true, response: null });
              }
              return resolve({ isCompleted: false, response: null });
          }
        },
          (result) => {
            // 不正応答コールバックが呼び出された場合も処理終了
            const cause = result.causeType;
            const behaviorType = result.behaviorType;
            // セッションが不正・ネットワークエラーならログアウト処理を行う(CC通信は行っていないのでCCエラーは対象外)
            if (cause === handler.causeTypes.networkError ||
              cause === handler.causeTypes.invalidSessionToken) {
              alert.showWarning(this, null, result.message, () => {
                if (behaviorType === handler.behaviorTypes.logout) {
                  this.logout(this);
                } else if (behaviorType === handler.behaviorTypes.resetSession) {
                  this.resetSession(this);
                }
              });
            } else {
              // その他のエラー
              this.showUnexpectedError(action);
            }
            // エラー扱いの為、responseをnullで返す
            resolve({ isCompleted: true, response: null });
            return;
          }, null, false);
      });
    },

    /**
     * その他のエラー発生時の処理を行う
     * @param {string} action 処理内容
     */
    showUnexpectedError(action) {
      // エラー発生時、ポーリングを停止する
      this.pollingStop();
      let messageKey;
      switch (action) {
        case DIAG_INIT:
          messageKey = 'individual.error_Initialize_communication_error';
          break;
        case DIAG_GET_DTC:
          messageKey = 'individual.error_failed_get_diag_code';
          break;
        case DIAG_READINESS:
          messageKey = 'individual.error_failed_decision_readiness_code';
          break;
        case DIAG_MEMORY_CLEAR:
          messageKey = 'individual.error_failed_dtc_delete';
          break;
        case DIAG_GET_FFD:
          messageKey = 'individual.error_failed_get_ffd';
          break;
      }
      alert.showError(this, null, this.$t(messageKey), () => {
        // エラーダイアログのOK押下後に制御作動履歴の通信を開始するため、通信完了を親に通知（統合画面用）
        this.$emit('diagApiStatusChange', { feature: 'dtc', status: 'error' });
      });
    },

    /* Start メモ用の関数一覧 */

    /**
     * メモダイアログを表示する
     */
    openNoteModal() {
      this.modalMemo = true;

      // テストモード用のメモ情報設定
      if (this.isTestMode) {
        this.$nextTick(() => {
          this.$refs.memo.diagnoseComment = this.memoData.diagnoseComment;
          this.$refs.memo.dataName = this.memoData.dataName;
          this.$refs.memo.memo = this.memoData.memo;
        });
      }
    },

    closeNoteModal() {
      this.modalMemo = false;
    },

    /**
     * メモ情報の保存
     */
    async memoSave() {
      // テストモード用のメモ情報設定
      if (this.isTestMode) {
        this.processing = true;
        this.memoData.diagnoseComment = this.$refs.memo.diagnoseComment;
        this.memoData.dataName = this.$refs.memo.dataName;
        this.memoData.memo = this.$refs.memo.memo;
        await util.sleep(1000);
        this.processing = false;
      }
      await this.$refs.memo.save();
    },

    /**
     * メモ情報のクリア
     */
    memoClear: function () {
      this.$refs.memo.clear();
    },

    /* end メモ用の関数一覧 */

    /**
     * 選択された連鎖DTCの状態に応じたボタンラベルを返す
     * @returns i18n用文字列
     */
    getChainDtcButtonLabel() {
      return CHAIN_DTC_MAP.find(elem => elem.type !== this.chainDtcType).label;
    },

    /**
     * 選択された連鎖DTCの状態に応じてテーブルを更新する
     */
    switchChainDtc() {
      // トグルボタンの切り替え
      if (this.chainDtcType === 'normal') {
        this.chainDtcType = 'all';
      } else {
        this.chainDtcType = 'normal';
      }
      if (this.getDiagCodeListResponse) {
        this.updateDTCTable();
      }
    },

    /* Start ReadinessCode用の関数一覧 */

    /**
     * レディネスコード押下時の処理を行う
     */
    openReadinessModal() {
      // 初期化
      this.initReadinessCode();
      this.modalReadiness = true;
    },

    /** レディネスコードダイアログ初期化 */
    initReadinessCode() {
      this.readinessCodeInputDtc = '';
      this.readinessCodeValidateDtc = undefined;
    },

    /** 追加ボタン押下 */
    onClickAddDtcReadinessCode() {
      // DTCの入力チェック
      this.readinessCodeInputDtc = this.readinessCodeInputDtc.trim().toUpperCase();
      if (!this.inputDtcCheckReadinessCode(this.readinessCodeInputDtc.trim())) {
        return;
      }
      // 入力されたDTCの行追加
      this.readinessCodeTable.push({
        readinessCodeDtc: this.readinessCodeInputDtc.trim(),
        readinessCodeDecisionResult: '',
        // レディネスコードの削除ボタンは常に表示されているため、trueを直接設定する
        buttonVisible: true
      });
      // 入力内容の初期化
      this.readinessCodeInputDtc = '';
      // レディネスコード計測データIDを初期化
      this.readinessCodeMeasuredId = null;
    },

    /**
     * DTCの入力チェック
     * @param {string} dtc 入力したDTC 
     * @returns バリデーション結果
     */
    inputDtcCheckReadinessCode: function (dtc) {
      this.readinessCodeValidateDtc = undefined;
      // 必須チェック
      if (dtc.length === 0) {
        this.readinessCodeValidateDtc = { valid: true, msg: 'message.alert_validate_required' };
        return false;
      }
      // 半角英数チェック
      if (!dtc.match(/^[PUBC][0-3][0-9A-F]+$/)) {
        this.readinessCodeValidateDtc = { valid: true, msg: 'message.alert_validate_invalid_pattern' };
        return false;
      }
      // 桁数チェック（5桁または7桁）
      if (dtc.length !== 5 && dtc.length !== 7) {
        this.readinessCodeValidateDtc = { valid: true, msg: 'message.alert_validate_invalid_pattern' };
        return false;
      }
      // 一覧への追加済チェック
      if (this.readinessCodeTable.some(item => item.readinessCodeDtc === dtc)) {
        this.readinessCodeValidateDtc = { valid: true, msg: 'individual.alert_validate_added' };
        return false;
      }
      return true;
    },

    /**
     * レディネスコード 行選択削除
     * @param {object} selected 選択した行の情報
     */
    deleteRowReadinessCode(selected) {
      // 選択した行のレディネスコードを削除
      this.readinessCodeTable = this.readinessCodeTable.filter(item => item.readinessCodeDtc !== selected.readinessCodeDtc);
      // レディネスコード計測データIDを初期化
      this.readinessCodeMeasuredId = null;
    },

    /** レディネスコードテーブルをすべて削除する */
    allDeleteReadinessCode() {
      this.readinessCodeTable = [];
      // レディネスコード計測データIDを初期化
      this.readinessCodeMeasuredId = null;
    },

    /** レディネスコード 判定ボタン押下 */
    async onClickDecisionReadinessCode() {
      try {
        if (this.readinessCodeTable.length === 0) {
          return;
        }
        this.processing = true;
        const systemId = individualDiagnose.getCurrentSystemId(this);
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        // リクエストボディを作成する
        const requestBody = {
          dtc: this.readinessCodeTable.map((item) => item.readinessCodeDtc)
        };
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.DIAG,
              `/netApps/${this.netAppId}/systems/${systemId}/readinessCodes`,
              requestBody
            );
          },
          // GET API 呼び出しのコールバック
          async (postApiResponse) => {
            return await api.getCall(
              config.DIAG,
              '/netApps/' + this.netAppId + '/systems/' + systemId + '/requests/' + postApiResponse.data.request_id
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(DIAG_READINESS); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // リクエストID が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data && postApiResponse.data.request_id ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            let result = config.INDIVIDUAL_POLLING_RESULT_ERROR;
            if (getApiResponse && getApiResponse.data && getApiResponse.data.status) {
              switch (getApiResponse.data.status) {
                case config.STATUS_REPRO_COMPLETED:
                  // ポーリング終了を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_FINISH;
                  break;
                case config.STATUS_REPRO_IN_PROGRESS:
                  // ポーリング続行を返す
                  result = config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
                  break;
                case config.STATUS_REPRO_FAILED:
                default:
                  // それ以外はエラー発生を返す
                  break;
              }
            }
            return result;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_READINESS); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_READINESS); },
        );

        if (response) {
          // 正常終了：レディネスコード判定の結果取得を行う
          this.readinessCodeMeasuredId = response.data.measured_id;
          const readinessResponse = await this.getReadinessCodeResult(response.data.measured_id);
          // レスポンスが存在しない場合、処理を中断する
          if (!readinessResponse) {
            return;
          }
          const result = readinessResponse.data.readiness_result;
          // レディネスコード判定処理
          this.readinessCodeTable.forEach(item => {
            if (result.some(data => data.code === item.readinessCodeDtc && data.readiness_status)) {
              item.readinessCodeDecisionResult = 'individual.label_diagnostic_incomplete';
            } else {
              item.readinessCodeDecisionResult = 'individual.label_diagnostic_complete';
            }
          });
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * レディネスコード判定の取得を行う関数
     * @param {string} readiness_measured_id GETから受け取ったレディネスコードの計測ID
     */
    async getReadinessCodeResult(readiness_measured_id) {
      try {
        const systemId = individualDiagnose.getCurrentSystemId(this);
        this.processing = true;
        const projectId = this.vehicleInfo.vehicle.project.id;
        // レディネスコード判定の取得（バックエンドAPI_GET）
        const response = await individualDiagnose.syncApi(
          this,
          // GET API 呼び出しのコールバック
          async () => {
            return await api.getCall(
              config.DIAG,
              `/diagDtc/${projectId}/${readiness_measured_id}/readinessCode/${systemId}`,
              this.operationScreen
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(DIAG_READINESS); },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            // data が入っていれば成功とする
            return getApiResponse && getApiResponse.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
          },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_READINESS); },
        );
        // 処理失敗時は response が null になるので考慮
        return response;
      } finally {
        this.processing = false;
      }
    },

    /* End ReadinessCode用の関数一覧 */

    /**
     * ダイアグコードのクリアを行う
     * @returns なし
     */
    deleteDTC() {
      // メモリクリアを実施できるシステムが１つも存在しなかった場合ダイアログ表示
      if (!this.getDiagCodeListResponse) {
        const messages = this.$t('message.message_vehicle_no_clear_dtc');
        alert.showInfo(this, null, messages);
        return;
      }
      // 強調文言
      const sentence = '<span style="color: red; font-size: 16px;">' + this.$t('message.message_vehicle_dtc_confirm_remove_dtc_operation') + '</span>';
      // DTC削除対象のシステム名
      const deleteDiagSystems = this.$t('diagSytem.EGI') + '/' + this.$t('diagSytem.EPS') + '/' + this.$t('diagSytem.ES');
      // 最終的なメッセージ
      const message = this.$t('individual.message_confirm_remove_dtc_individual', [sentence, deleteDiagSystems]);

      // 確認ダイアログ
      alert.showConfirmation(
        this,
        null,
        message,
        // 続行時のコールバック
        () => {

          this.cacheFFDStores([]);

          // メモリクリア Action を開始
          this.executeClearAction();
        }
      );
    },

    /**
     * メモリクリア Action を非同期で実行する
     * 個別 ECU のメモリクリア実施⇒成功時は結果画面表示
     * @returns なし
     */
    async executeClearAction() {
      try {
        // 個別 ECU の DTC データを取得する
        const systemId = individualDiagnose.getCurrentSystemId(this);
        this.processing = true;
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        const response = await individualDiagnose.pollingApi(
          this,
          // POST API 呼び出しのコールバック
          async () => {
            return await api.postCall(
              config.DIAG,
              `/netApps/${this.netAppId}/systems/${systemId}/clearDtc`, {}
            );
          },
          // GET API 呼び出しのコールバック
          async () => {
            return await api.getCall(
              config.DIAG,
              `/pairings/${this.netAppId}`
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(DIAG_MEMORY_CLEAR); },
          // POST API レスポンスチェックのコールバック
          (postApiResponse) => {
            // レスポンスデータ が正常に返ってきたら成功とする
            return postApiResponse && postApiResponse.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_POST_INVALID_RESPONSE;
          },
          // GET API レスポンスチェックのコールバック
          (getApiResponse) => {
            // 正常コールバック
            if (getApiResponse.data.is_clear_dtc_completed) {
              // エラーコードが0以外、またはエラーメッセージが存在する場合、
              // 処理が失敗した判定なので、エラーを返却する
              if (getApiResponse.data.err_code !== 0 || getApiResponse.data.err_msg) {
                return config.INDIVIDUAL_POLLING_RESULT_ERROR;
              } else {
                // それ以外の場合は成功とし、ポーリングを完了とする
                return config.INDIVIDUAL_POLLING_RESULT_FINISH;
              }
            } else {
              return config.INDIVIDUAL_POLLING_RESULT_CONTINUE;
            }
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_MEMORY_CLEAR); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result, DIAG_MEMORY_CLEAR); },
        );
        if (response) {
          // クリア結果を取得する
          const resultFlag = await this.getClearDtcResult();
          // 消去の正否に関わらず、削除結果画面を表示する
          this.resultMemoryClear(resultFlag);
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * 対象システムのメモリクリア結果を取得し、成否を返却する
     * @returns boolean クリア結果
     */
    async getClearDtcResult() {
      // 結果フラグ
      let resultFlag = false;
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const response = await individualDiagnose.syncApi(
        this,
        // GET API 呼び出しのコールバック
        async () => {
          return await api.getCall(
            config.DIAG,
            `/diagDtc/clearDtcResult/${this.netAppId}`,
            this.operationScreen
          );
        },
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(DIAG_MEMORY_CLEAR); },
        // GET API レスポンスチェックのコールバック
        (getApiResponse) => {
          // results が入っていれば成功とする
          return getApiResponse && getApiResponse.data && getApiResponse.data.results ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
        },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result, DIAG_MEMORY_CLEAR); },
      );
      if (response) {
        // 正常コールバック
        const results = response.data.results;
        // 結果配列から、システムネームが一致しているobjectを抽出
        const targetResult = results.find(result => result.system_name === systemId);
        // is_clear_dtc_successがtrueの場合、削除成功とする
        resultFlag = !!(targetResult && targetResult.is_clear_dtc_success);
      }
      return resultFlag;
    },

    /**
     * DTC削除の結果画面の表示
     * @param {boolean} 消去成功/失敗フラグ 
     */
    resultMemoryClear(resultFlag) {
      let messages = null;
      const removeOperation = '<span style="color: red; font-size: 16px;">' + this.$t('message.message_vehicle_dtc_complete_remove_dtc_operation') + '</span>';
      const removeFooter = this.$t('individual.message_info_dtc_re_get');

      if (resultFlag) {
        // 消去成功メッセージ
        const removeHeader = this.$t('individual.message_complete_dtc_delete');
        messages = ('{0}\r\n\r\n{1}\r\n\r\n{2}').format(removeHeader, removeOperation, removeFooter);
      } else {
        // 消去失敗メッセージ
        const removeFailure = this.$t('individual.error_failed_dtc_delete');
        messages = ('{0}\r\n\r\n{1}\r\n\r\n{2}').format(removeFailure, removeOperation, removeFooter);
      }

      alert.showInfo(this, null,
        messages,
        async () => {
          // 個別診断DTCの利用回数カウントアップ
          const systemId = individualDiagnose.getCurrentSystemId(this);
          this.usageCountUp({ type: DTC, systemName: systemId });
          // DTCデータの再取得
          this.getDiagCodeRequest();
        });
    },


    /* Start FFD用の関数一覧 */

    /**
     * FFD ボタン押下時の処理を行う
     * @param {object} data 押下したデータ
     * @returns なし
     */
    async clickFFD(data) {
      if (!data) return;
      // 計測中(Stopボタンが見えている間)はFFD表示不可
      if (this.isShowStopBtn) {
        this.inExecutionAlert();
        return;
      }
      // タイトルの設定
      const status = data.status ? ` (${this.$t(data.status)}) ` : '';
      let unitResponse = null;
      this.ffdTitle = data.dtc + status;
      this.ffdSystem = this.$t(data.name);
      this.ffdDescription = this.$t(data.description);
      // テストモードの場合はユーザー設定の単位取得
      if (this.isTestMode) {
        this.processing = true;
        unitResponse = await api.getCall(config.ADMIN, '/unitSettings');
        this.processing = false;
        // APIレスポンスの検証
        handler.validate(handler.validateTypes.all, unitResponse, this, null, () => {
        },
          (result) => {
            // 処理が失敗したときのコールバック処理
            if (result.behaviorType === handler.behaviorTypes.logout) {
              this.logout(this);
            }
          });
      }
      const cache = this.cachedFFDs.filter(e => e.system === data.systemID && e.dtc === data.dtc);
      if (cache.length > 0) {
        // キャッシュ有りならキャッシュ済みデータを表示
        this.ffdSystemTable = cache[0].data;
        this.selectedSystem = data;
        if (this.isTestMode) {
          diag.checkUnit(unitResponse, this.ffdSystemTable, this);
        }
        this.modalFfd = true;
      } else {
        // キャッシュなしなら FFD 一覧情報を取得
        this.processing = true;
        const ffdResponse = await this.getFfdResponse(data.dtc, data.systemID);
        this.processing = false;

        // responseが存在しない場合、処理終了
        if (!ffdResponse) {
          return;
        }
        // キャッシュの更新
        this.cacheFFDStores([...this.cachedFFDs, { system: data.systemID, dtc: data.dtc, data: ffdResponse }]);

        // FFDダイアログの表示
        this.ffdSystemTable = ffdResponse;
        this.selectedSystem = data;
        if (this.isTestMode) {
          diag.checkUnit(unitResponse, this.ffdSystemTable, this);
        }
        this.modalFfd = true;
      }
    },

    /**
     * FFD一覧情報取得を行う関数
     * @param {string} dtc 選択したdtc
     * @param {string} systemId systemId
     */
    async getFfdResponse(dtc, systemId) {
      try {
        this.processing = true;
        const projectId = this.vehicleInfo.vehicle.project.id;
        // Get APIを呼び出す
        const response = await individualDiagnose.syncApi(
          this,
          async () => {
            return await api.getCall(
              config.DIAG,
              `/diagDtc/${projectId}/${this.measuredId}/ffd/${systemId}/${dtc}`,
              this.operationScreen
            );
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(DIAG_GET_FFD); },
          // GET API で正常レスポンスが返ってきた際の内容チェック
          (getApiResponse) => {
            // data が入っていれば成功とする
            return getApiResponse && getApiResponse.data && getApiResponse.data.data ? '' : config.INDIVIDUAL_API_CALL_ERROR_GET_INVALID_RESPONSE;
          },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result, DIAG_GET_FFD); },
        );
        // 処理失敗時は response が null になるので考慮
        return response ? response.data.data : null;
      } finally {
        this.processing = false;
      }
    },

    /* End FFD用の関数一覧 */

    /**
     * カラムを作り直す
     */
    updateColumns() {
      const systemId = individualDiagnose.getCurrentSystemId(this);
      // ダイアグコードレスポンスが空の場合、return
      if (!this.getDiagCodeListResponse) {
        return;
      }
      const igonCntVar = util.mkHeaderValue(this.getDiagCodeListResponse.current_igon_time);
      const igonCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igonCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonCntVar;
      const igonTimeVar = util.mkHeaderValue(this.getDiagCodeListResponse.current_igon_mill_sec);
      const igonTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igonTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igonTimeVar;
      // システムによる分岐
      if (DiagSystemUtils.isEyesightByAbbreviationId(getAbbrSysName(systemId))) {
        // ESの場合、ECU独自仕様対応
        this.dtcSystemTableColumns = [
          { name: 'status', label: 'message.header_vehicle_dtc_table_status', useResource: true },
          { name: 'dtc', label: 'message.header_vehicle_dtc_table_code', originalSortFunc: diagnoResource.sortFuncCode },
          { name: 'description', label: 'message.header_vehicle_dtc_table_description', useResource: true, originalSortFunc: diagnoResource.sortFuncDescription },
          { name: 'igonCount', label: util.setColums(igonCnt, igonCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
          { name: 'igonTime', label: util.setColums(igonTime, igonTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
          { name: 'counterType', label: 'message.header_vehicle_dtc_table_type' },
          { name: 'occurrenceDate', label: 'individual.label_dtc_es_specific_occurrence_time', originalSortFunc: diagnoResource.sortDate },
          { name: 'ffd', label: 'message.header_vehicle_dtc_table_ffd', useButton: true, useResource: true, originalSortFunc: diagnoResource.sortFuncFfd },
        ];
      } else {
        // 通常
        this.dtcSystemTableColumns = [
          { name: 'status', label: 'message.header_vehicle_dtc_table_status', useResource: true },
          { name: 'dtc', label: 'message.header_vehicle_dtc_table_code', originalSortFunc: diagnoResource.sortFuncCode },
          { name: 'description', label: 'message.header_vehicle_dtc_table_description', useResource: true, originalSortFunc: diagnoResource.sortFuncDescription },
          { name: 'igonCount', label: util.setColums(igonCnt, igonCounterValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
          { name: 'igonTime', label: util.setColums(igonTime, igonTimeValue, "{0} {1}", true), useHtmlBind: true, originalSortFunc: diagnoResource.sortIgon },
          { name: 'counterType', label: 'message.header_vehicle_dtc_table_type' },
          { name: 'ffd', label: 'message.header_vehicle_dtc_table_ffd', useButton: true, useResource: true, originalSortFunc: diagnoResource.sortFuncFfd },
        ];
      }
    },

    /**
     * テーブル情報更新処理を行う
     */
    updateDTCTable() {
      const systemId = individualDiagnose.getCurrentSystemId(this);
      // システムに紐づく DTC があるかチェックする
      // ※連鎖 DTC 表示有無を考慮
      let filteredDtcSystems = [];
      if (this.getDiagCodeListResponse) {
        filteredDtcSystems = this.getDiagCodeListResponse.data
          .filter(dtc => dtc.system === systemId)
          .filter(dtc => this.chainDtcType === 'all' || !dtc.is_chain_dtc);
      }

      // フィルターしたDTC情報から、テーブルを作成する
      this.dtcListItems = resource.createDtcTable(filteredDtcSystems, systemId, this);
    },

    /**
     * DTC情報をCSVエクスポートする
     */
    async csvExport() {
      const fileInfo = {};
      let resultInfo = {};
      // 行のフォーマット
      resultInfo = this.dtcListItems.map(item => {
        return {
          ...item,
          status: this.$t(item.status),
          description: this.$t(item.description),
          ffd: item.buttonVisible ? this.$t('message.available_ffd') : this.$t('message.no_ffd')
        };
      });

      // 列のフォーマット
      const igOnCntVar = util.mkHeaderValue(this.getDiagCodeListResponse.current_igon_time);
      const igOnCnt = this.$t('message.header_vehicle_dtc_table_igon_counts');
      const igOnCounterValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnCntVar;
      const igOnTimeVar = util.mkHeaderValue(this.getDiagCodeListResponse.current_igon_mill_sec);
      const igOnTime = this.$t('message.header_vehicle_dtc_table_igon_times');
      const igOnTimeValue = this.$t('message.header_vehicle_dtc_table_measurement_value') + ': ' + igOnTimeVar;

      fileInfo.column = this.dtcSystemTableColumns.map(column => {
        if (column.name === 'igonCount') {
          column.label = igOnCnt + " " + igOnCounterValue;
        } else if (column.name === 'igonTime') {
          column.label = igOnTime + " " + igOnTimeValue;
        }
        return column;
      });

      // VINデータのフォーマット
      const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}","${this.vehicleInfo.vehicle.vin.vin}"\n`;

      // 出力形式の設定
      const headers = fileInfo.column.map(column => {
        if (column.name === 'igonCount' || column.name === 'igonTime') {
          return { id: column.name, title: column.label };
        } else {
          return { id: column.name, title: this.$t(column.label) };
        }
      });

      // 説明・故障部位のエスケープ処理
      fileInfo.record = util.escapeDoubleQuotation(resultInfo, 'description');

      // CSVファイルエクスポート処理
      const data = vinHeader + util.createCsvData(headers, fileInfo.record);

      let endPoint = '';
      // トレーニングモードは保持しているデータ名を使用
      let measuredDataName = this.isTestMode ? this.testModeMeasuredDataName : '';

      if (!this.isTestMode && this.vehicleInfo.vehicle.project.id !== null && this.measuredId !== null) {
        try {
          this.processing = true;
          // プロジェクトIDおよび計測データIDが存在する場合、計測データ取得APIを指定
          endPoint = '/projects/' + this.vehicleInfo.vehicle.project.id + '/' + this.measuredId;
          // 計測データ名を取得
          measuredDataName = await getMeasuredDataName(this, this.destinationAPI, endPoint, this.operationScreen);
        } finally {
          this.processing = false;
        }
      }
      const fileName = getCsvFileName(this.$t('individual.individual_diagnosis_function_diag_code'), measuredDataName, this.vehicleInfo.vehicle.vin.vin);

      // CSVファイルエクスポート処理
      util.csvFileExport(data, fileName);
    },

    /**
     * レディネスコード情報をCSVエクスポートする
     */
    async readinessCodeCsvExport() {
      const fileInfo = {};
      // 行のフォーマット
      fileInfo.record = this.readinessCodeTable.map(item => {
        return {
          ...item,
          readinessCodeDecisionResult: this.$t(item.readinessCodeDecisionResult)
        };
      });

      // VINデータのフォーマット
      const vinHeader = `"${this.$t('message.label_measured_data_search_vin')}","${this.vehicleInfo.vehicle.vin.vin}"\n`;

      // 出力形式の設定
      const headers = this.readinessCodeTableColumns.filter(item => item.name !== 'delete').map(column => {
        return { id: column.name, title: this.$t(column.label) };
      });

      // CSVファイルエクスポート処理
      const data = vinHeader + util.createCsvData(headers, fileInfo.record);

      let endPoint = '';
      // トレーニングモードは保持しているデータ名を使用
      let measuredDataName = '';

      if (this.vehicleInfo.vehicle.project.id !== null && this.readinessCodeMeasuredId !== null) {
        try {
          this.processing = true;
          // プロジェクトIDおよび計測データIDが存在する場合、計測データ取得APIを指定
          endPoint = '/projects/' + this.vehicleInfo.vehicle.project.id + '/' + this.readinessCodeMeasuredId;
          // 計測データ名を取得
          measuredDataName = await getMeasuredDataName(this, this.destinationAPI, endPoint, this.operationScreen);
        } finally {
          this.processing = false;
        }
      }
      const fileName = getCsvFileName(this.$t('individual.label_readiness_code'), measuredDataName, this.vehicleInfo.vehicle.vin.vin);

      // CSVファイルエクスポート処理
      util.csvFileExport(data, fileName);
    },

    /* Start テスト用の関数一覧 */

    /**
     * DIDのテストデータ出力を行う
     */
    didTestDataExport() {
      const ffd = this.$refs.ffd_modal.getTestData();
      const test = this.createFFDTestData(this.ffdSystemTable, ffd.items);
      // テストdataを生成する
      // 独自のsortIDでソート
      test.info.sort((a, b) => {
        if (a.sortId < b.sortId) return -1;
        if (a.sortId > b.sortId) return 1;
        return 0;
      });
      // データモニター表示順でソート
      test.info.sort((a, b) => {
        if (a.monitor_order < b.monitor_order) return -1;
        if (a.monitor_order > b.monitor_order) return 1;
        return 0;
      });
      // 独自のsortID削除
      test.info.forEach(element => {
        delete element.sortId;
      });

      if (test.info.length > 0) {
        const systemName = this.removeResourceKey(this.selectedSystem.name);
        const csvArray = [[], [], []];
        ffd.items.forEach(ffdData => {
          csvArray[0].push(this.$t(ffdData.item));
          csvArray[1].push(this.$t(ffdData.unit));
          csvArray[2].push(ffdData[0]);
        });

        let csvData = '';
        csvArray.forEach(a => {
          const row = a.join(',');
          csvData += row + '\r\n';
        });
        const bomFormatData = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const csvBlob = new Blob([bomFormatData, csvData],
          {
            type: 'text/csv;charset=utf-8',
          });
        const csvLink = document.createElement('a');
        csvLink.href = URL.createObjectURL(csvBlob);
        csvLink.download = ('{0}_DID_FRONT.csv').format(systemName); // 出力するファイルの名前
        csvLink.click();
        csvLink.remove();

        const blob = new Blob([JSON.stringify(test, null, '  ')], {
          type: 'application/json',
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = ('{0}_DID_FRONT.json').format(systemName); // 出力するファイルの名前
        link.click();
        link.remove();
      }
    },

    /**
     * FFD のテストデータ作成を行う
     * @param {object} originalData 元のデータ
     * @param {object} tableData テストデータ
     * @returns 成形後のテストデータ
     */
    createFFDTestData(originalData, tableData) {
      const result = { info: [] };

      // 取得したデータを ffd_save_order で振り分ける
      const groupBySystem = util.groupBy(originalData, 'ffd_save_order');
      // 優先して最新(確定)のデータのみ取得する。
      let currentData = null;
      if (util.isKeyExists(groupBySystem, '0')) {
        currentData = groupBySystem['0'];
      } else {
        currentData = groupBySystem['1'];
      }

      if (currentData) {
        tableData.forEach(element => {
          const keyId = this.removeResourceKey(element.item);
          const index = currentData.findIndex(item => item.id === keyId);
          if (index === -1) {
            logWrapper.log('ID not found in current data.', keyId);
          }
          else {
            let keyIndex = 0;
            // 10個のキー名までチェックする。
            for (let index = 0; index < 10; index++) {
              keyIndex = String(index);
              if (util.isKeyExists(element, keyIndex)) {
                // keyが存在した場合は処理終了
                break;
              }
            }
            const valueKey = 'value_' + keyIndex;
            const resourceIdKey = 'resouceId_' + keyIndex;

            // テストデータは検出時のみを取得する。
            const findData = currentData[index];

            let sortId = "";
            const keyUnderSplit = keyId.split('_');
            if (keyUnderSplit.length > 1) {
              const second = keyUnderSplit[1].padStart(2, '0');
              sortId = keyUnderSplit[0] + '_' + second;
            }
            if (keyUnderSplit.length > 2) {
              const covertNumber = Number(keyUnderSplit[2]);
              if (!isNaN(covertNumber)) {
                const third = keyUnderSplit[2].padStart(covertNumber, '0');
                sortId = sortId + '_' + third;
              }
            }

            const testData = {
              id: keyId,
              sortId: sortId,
              unit: this.removeResourceKey(element.unit),
              digits_after_decimal: findData.digits_after_decimal,
              data_type: findData.data_type,
              value: String(this.roundValue(element[valueKey])),
              value_resource_id: this.removeResourceKey(element[resourceIdKey]),
              monitor_order: findData.monitor_order
            };
            result.info.push(testData);
          }
        });
      }
      return result;
    },

    /**
     * i18n用文字列の先頭を削除する
     * @param {string} resourceId リソースID
     * @returns メッセージのキー
     */
    removeResourceKey(resourceId) {
      let result = "";
      // 設定されていない場合は""文字列で戻す
      if (!resourceId) {
        return result;
      }
      const resources = resourceId.split('.');
      if (resources.length > 0) {
        result = resources[1];
      }
      return result;
    },

    /**
     * 小数点以下第10位に変換する
     * @param {*} value 数値
     * @returns 変換後の小数
     */
    roundValue(value) {
      let result = value;
      if (value) {
        if ((typeof value) === "number") {
          result = value.toFixed(10);
        }
      }
      return result;
    },

    /* End テスト用の関数一覧 */

    /**
     * 呼び出し時のコンポーネント内ガードの共通処理
     * @param vm 呼び出し元のオブジェクト(this)
     * @param from 遷移元 
     */
    beforeRouteProcess(vm, from) {
      if (util.isFromSettingsPage(from.name) || util.isSameSystemPage(from)) {
        // 単位設定画面またはパスワード変更画面からの遷移時、または同じシステム内の子機能間への遷移の場合 trueを指定
        vm.isUseCache = true;
      } else {
        // 上記以外の場合、falseを指定
        vm.isUseCache = false;
      }
    },

    /**
     * DTC ポーリングを開始する
     */
    async pollingStart() {
      // FFDキャッシュを削除
      this.cacheFFDStores([]);
      // 個別診断DTCの利用回数カウントアップ
      const systemId = individualDiagnose.getCurrentSystemId(this);
      this.usageCountUp({ type: DTC, systemName: systemId });
      this.isShowStopBtn = true;
      // ツリーを非表示にするために、viewProcessModeに独自のパラメータを設定
      this.setViewProcessMode('dtc_polling');
      this.pollingProcessing = true;
      await this.pollingProcess(true);
    },

    /**
     * ポーリング処理
     * @param {boolean} eventLogHandleIdFlg 開始ボタンを押下して最初のダイアグ取得のみ true（イベントログの操作 ID 発行する）とする
     */
    async pollingProcess(eventLogHandleIdFlg = false) {
      this.isExecution = true;
      await this.getDiagCodeRequest(eventLogHandleIdFlg);
      this.isExecution = false;
      if (!this.isShowStopBtn) return;
      this.timer = setTimeout(async () => {
        await this.pollingProcess(false);
      });
    },

    /**
     * DTC ポーリングを停止する
     */
    pollingStop() {
      this.isShowStopBtn = false;
      // ツリーを再表示にするために、viewProcessModeにidlingを設定
      this.setViewProcessMode(config.PROCESS_IDLING);
      clearTimeout(this.timer);
      if (!this.isExecution) {
        this.pollingProcessing = false;
      }
    },

    /** 計測中警告ダイアログ */
    inExecutionAlert() {
      alert.showWarning(
        this,
        null,
        this.$t("individual.alert_diag_code_measurement"),
        () => { }
      );
    },
  },

  computed: {

    ...mapState({
      userProperty: state => state.userProperty,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      // メニューサポートの情報
      language: state => state.systems.language,
      // クラウドコネクターの接続状況
      netAppId: state => state.netAppConnector.pairingAppId,
      cachedFFDs: state => state.cache.ffdStores,
      individualMenus: state => state.vehicle.individualMenus,
      isTestMode: state => state.netAppConnector.isTestMode,
      isPopstateNavigation: state => state.cache.isPopstateNavigation,
    }),

    /**
     * レディネスコードボタンの表示有無を判定する
     * @returns true:表示, false:非表示
     */
    isVisibleReadinessCodeButton() {
      // メニューサポートからレディネスコードの表示非表示情報を取得
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const menuList = this.individualMenus && this.individualMenus.menu_list ? this.individualMenus.menu_list : [];
      const targetMenu = menuList.find((menu) => menu.system_name === systemId);
      return (targetMenu && targetMenu.menu_display_config && targetMenu.menu_display_config.readiness_code) || false;
    },

    // レディネスコード
    readinessCodeTableColumns() {
      return [
        { name: 'readinessCodeDtc', label: 'individual.header_readiness_code_dtc' },
        { name: 'readinessCodeDecisionResult', label: 'individual.header_readiness_code_result', useResource: true },
        { name: 'delete', label: 'individual.label_readiness_code_delete', useButton: true },
      ];
    },

    /**
     * 診断系のAPIは複数画面から使用されているため
     * 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する
     * @returns 使用元の機能
     */
    operationScreen() {
      return diagnoResource.operationFrom(this.$router.currentRoute.value.name);
    },
    /** トレーニングモードでCSVのファイル名に使用するデータ名 */
    testModeMeasuredDataName() {
      return this.isTestMode ? this.memoData.dataName : '';
    }

  },

  /**
   * コンポーネント生成時の処理を行う
   */
  created() {
    // イベントログのページビューカウント
    // 統合画面（IndividualDtcVch）の場合は統合画面でカウントされる。個別DTC画面の場合のみカウント実行
    if (!this.limitedHeightMode) {
      eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_INDIVIDUAL_DTC);
    }
  },

  /**
   * DOM 生成後の処理を行う
   */
  mounted() {
    this.mountedLogic();
  },


  /** 画面遷移時、計測中か判定 */
  beforeRouteLeave(to, from, next) {
    if ((to.name === "login") && (to.fullPath === "/") && (to.path === "/")) {
      this.pollingStop();
      this.isSignOut = true;
      next();
      return;
    }
    // 計測中(Stopボタンが見えている間)は移動不可
    if (this.isShowStopBtn) {
      this.inExecutionAlert();
    } else {
      next();
    }
  },

  /**
   * コンポーネント終了前の処理を行う
   */
  beforeUnmount() {
    this.pollingStop();
    // debug 環境のみ実施有効とする
    if (process.env.VUE_APP_DEBUG_LOG) {
      // onkeydown の再登録
      document.onkeydown = (event) => {
        return util.checkSSM5ValidCharacters(event);
      };
    }
  },
};
